<div class="information-area  access ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="information-content">
                    <span class="sub-title">Informations</span>
                    <h2>Les avantages de EULOGIA</h2>
                    <ul class="apply-details">
                        <li>
                            <div class="icon">
                                <i class="flaticon-checkmark"></i>
                            </div>
                            <!-- <h3>Une équipe qui t’accompagne personnellement dans ta formation</h3> -->
                            <p>Une équipe qui t’accompagne personnellement dans ta formation</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="flaticon-webinar"></i>
                            </div>
                            <!-- <h3>Des intervenants ayant un témoignage rempli de l’esprit et éprouvé par la Parole </h3> -->
                            <p>Des intervenants ayant un témoignage rempli de l’esprit et éprouvé par la Parole</p>
                        </li>
                        <!-- <li>
                            <div class="icon">
                                <i class="flaticon-credit-card-1"></i>
                            </div>
                            <h3>Payment Information</h3>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.</p>
                        </li> -->
                        <li>
                            <div class="icon">
                                <i class="flaticon-verify"></i>
                            </div>
                            <!-- <h3>Des échanges enrichissants sur des sujets essentiels.</h3> -->
                            <p>Des échanges enrichissants sur des sujets essentiels.</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="information-image text-center">
                    <img src="assets/img/information-img.png" alt="image">
                </div>
            </div>
        </div>
    </div>
</div>